import { BrowserRouter } from 'react-router-dom';
import { AuthContextProvider } from 'context/authContext';
import { StyledToastContainer } from 'styles/App.styles';
import GlobalStyles from 'styles/GlobalStyles.styles';
import { LoadingContextProvider } from 'context/loadingContext';
import { SideNavContextProvider } from 'context/sideNavContext';
import { FiltersContextProvider } from 'context/filtersContext';
import { PerformanceFiltersContextProvider } from 'context/performanceFiltersContext';
import { ThemeProvider } from 'context/themeContext';
import Router from './Router';
import 'rc-picker/assets/index.css';
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-loading-skeleton/dist/skeleton.css';
import 'swiper/swiper.css';
import 'swiper/swiper-bundle.min.css';

function App() {
  return (
    <LoadingContextProvider>
      <ThemeProvider>
        <SideNavContextProvider>
          <PerformanceFiltersContextProvider>
            <FiltersContextProvider>
              <GlobalStyles />
              <BrowserRouter>
                <AuthContextProvider>
                  <Router />
                </AuthContextProvider>
              </BrowserRouter>
              <StyledToastContainer />
            </FiltersContextProvider>
          </PerformanceFiltersContextProvider>
        </SideNavContextProvider>
      </ThemeProvider>
    </LoadingContextProvider>
  );
}

export default App;
